import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable()
export class ConfirmDialogService {
  private confirmDialogNotify: Subject<any> = new Subject<any>();
  public confirmDialogObservable: Observable<any> =
    this.confirmDialogNotify.asObservable();

  public createConfirmDialog(params: any) {
    this.confirmDialogNotify.next(params);
  }
}
